import $ from 'jquery';

// Dropdown filter
export default class SearchBox {

  constructor($element, options) {
    this.$element = $element;
    this.index = {};
    this.path = $element.data('wjp-job-path');
    $element.find('.wjp-jobs-filter-submit').on('click', this.onSubmit.bind(this));
  }

  onSubmit() {
    this.filters = this.getFilters();

    const request = this.createRequest();
    window.location.href = this.path + '?' + request;
  }

  getFilters() {
    const filters = [];
    this.$element.find('[data-wjp-filter]').each((index, element) => {
      let filter = $(element).get(0).filter;
      filters.push(filter);
    });
    return filters;
  }

  updateIndex() {
    for(let i=0; i < this.filters.length; i++) {
      let filter = this.filters[i];

      if(filter.isActive) {
        if(filter.getValue()) {
          this.index[filter.getKey()] = filter.getValue();
        } else {
          delete this.index[filter.getKey()];
        }
      }
    }
  }

  createRequest() {
    let strings = [];

    this.updateIndex();

    for (let key in this.index) {
       let value = this.index[key];
       if(this.index.hasOwnProperty(key)){
           let string = "";
           value = (typeof value === 'string') ? [ value ] : value;
           if(typeof value[0] !== "undefined") {
              string += key + "=" + value.join('+');
              strings.push(string);
           }
       }
    }
    let output = strings.join("&");
    return (output) ? output : "";
  }

}



/** WEBPACK FOOTER **
 ** ../assets/js/components/SearchBox.js
 **/